export type AuthTransitionDirection = 'forward' | 'backward';

export type AuthJourneyState = {
  authJourney: true;
  authTransitionDirection: AuthTransitionDirection;
};

export const createAuthJourneyState = (
  direction: AuthTransitionDirection
): AuthJourneyState => ({
  authJourney: true,
  authTransitionDirection: direction,
});

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const readAuthJourneyState = (
  state: unknown
): AuthJourneyState | null => {
  if (!isRecord(state) || state.authJourney !== true) return null;

  const direction = state.authTransitionDirection;
  if (direction !== 'forward' && direction !== 'backward') return null;

  return createAuthJourneyState(direction);
};

export const resolveAuthTransitionDirection = (
  navigationType: 'POP' | 'PUSH' | 'REPLACE',
  state: unknown,
  previousHistoryIndex: unknown,
  currentHistoryIndex: unknown
): AuthTransitionDirection | null => {
  if (
    navigationType === 'POP' &&
    typeof previousHistoryIndex === 'number' &&
    typeof currentHistoryIndex === 'number' &&
    Number.isInteger(previousHistoryIndex) &&
    Number.isInteger(currentHistoryIndex) &&
    previousHistoryIndex !== currentHistoryIndex
  ) {
    return currentHistoryIndex < previousHistoryIndex ? 'backward' : 'forward';
  }

  const explicitState = readAuthJourneyState(state);
  return explicitState?.authTransitionDirection ?? null;
};

export const isAuthJourneyEntry = (state: unknown): boolean =>
  readAuthJourneyState(state) !== null;
